export default __webpack_public_path__ + "static/media/pitchlogo.67841806.png";